import Formsy from "formsy-react";
import FormsyDatePicker from "../../elements/FormsyDatePicker";
import FormsyInputField from "../../elements/FormsyInputField";
import { useMemo } from "react";
import { FIELDS_TO_DISABLE_IF_EXIST, isNeedsToDisable } from "../../../config/constants";
import FormsyTextAreaAutosize from "../../elements/FormsyTextAreaAutosize";
const { CREDIT_ADVICE_RECEIVED } = FIELDS_TO_DISABLE_IF_EXIST;
const now = new Date();

const VehicleTransferCreditInvestigation = ({ props, setAllowSubmit, saveFormDetails, current_page_fields, vehicleAndSoftCreditData, handleInputChange, current_page, vehicleAndSoftCreditDataExisted, FinancingFromMinDate, FinancingFromMaxDate, form_read_only, maxTime, vehicleAndSoftCreditDocuments, markAsFreezed, handleFileChange, isValidDateSubmit, allowSubmit, isValidFileSubmit, isFileUploaded, accessCondition, showModalViewTimeLine, remarksHistory }) => {
    const isSaveNextDisabled = useMemo(() => {
        const isDateInvalid = current_page === "credit_advice_received" ? !isValidDateSubmit : !allowSubmit;
        const isFileInvalid = ["credit_advice_received", "orcr_received", "orcr_sent_for_title_transfer", "orcr_received_after_title_transfer"].includes(current_page)
            ? !isValidFileSubmit
            : !isFileUploaded;
      
        return form_read_only || isDateInvalid || isFileInvalid || markAsFreezed || accessCondition;
    }, [
        form_read_only,
        current_page,
        isValidDateSubmit,
        allowSubmit,
        isValidFileSubmit,
        isFileUploaded,
        markAsFreezed,
        accessCondition
    ]);
      
    return <div className={" switch-toggle"}>
        <div className="lead-form-heading">
            <h2>{props.name}</h2>
        </div>
        <div className="soft-approvel-sec">
            <Formsy
                className="lead-form-filed"
                autoComplete="off"
                onValid={() => setAllowSubmit(true)}
                onInvalid={() => setAllowSubmit(false)}
                onValidSubmit={saveFormDetails}
            >
                <div className="row">
                    {current_page_fields.map((field) => (
                        ["text", "pattern-format"].includes(field.type) ? (
                            <fieldset className="form-filed col-md-12 ">
                                <div className="material">
                                    <FormsyInputField
                                        id={field.id}
                                        name={field.name}
                                        type={field.type}
                                        value={vehicleAndSoftCreditData && vehicleAndSoftCreditData[field.name]}
                                        placeholder=" "
                                        label={field.label}
                                        onChange={e => handleInputChange(field.name, field.type, e)}
                                        format={field.ApplyNumberformat ? field.format : ""}
                                        required={field.required}
                                        readOnly={(["credit_advice_received"].includes(current_page) && isNeedsToDisable(field?.name, CREDIT_ADVICE_RECEIVED, vehicleAndSoftCreditDataExisted?.[field?.name])) || field.readOnly}
                                        col={"col-md-12"} />
                                </div>
                            </fieldset>
                        ) :
                            field.type === "date-picker" ? (
                                <fieldset className="form-filed col-md-12">
                                    <div className="material date-filed">
                                        <FormsyDatePicker
                                            name={field.name}
                                            selectedDate={vehicleAndSoftCreditData && vehicleAndSoftCreditData[field.name] && new Date(vehicleAndSoftCreditData[field.name])}
                                            value={(vehicleAndSoftCreditData && vehicleAndSoftCreditData[field.name] && Date.parse(vehicleAndSoftCreditData[field.name])) || ''}
                                            placeholder={field.label}
                                            minDate={field.name === "financing_from_date" ? FinancingFromMinDate : field.name === "financing_till_date" ? new Date(vehicleAndSoftCreditData["financing_from_date"]).setMonth(new Date(vehicleAndSoftCreditData["financing_from_date"]).getMonth() + 6) : ""}
                                            maxDate={field.name === "financing_from_date" ? FinancingFromMaxDate : field.name === "financing_till_date" ? "" : new Date()}
                                            onDateSelect={(e) => !form_read_only ? handleInputChange(field.name, field.type, e) : e.preventDefault()}
                                            dateFormat="dd MMM, yyyy h:mm aa"
                                            showTimeSelect={true}
                                            minTime={now.setHours(0, 0, 0)}
                                            maxTime={["financing_from_date", "financing_till_date"].includes(field.name) ? now.setHours(23, 59, 59, 999) : maxTime}
                                            validations={field.validations}
                                            validationError={current_page_fields[field.name] ? field.validationError : ""}
                                            required={field.required}
                                            hasError={(current_page_fields.hasOwnProperty(field.name) && !current_page_fields[field.name]) ? true : false}
                                            readOnly={(["credit_advice_received"].includes(current_page) && isNeedsToDisable(field?.name, CREDIT_ADVICE_RECEIVED, vehicleAndSoftCreditDataExisted?.[field?.name])) || ((field.name === "financing_till_date" && !vehicleAndSoftCreditData["financing_from_date"]) || field.readOnly || form_read_only)}
                                            onBlur={(e) => console.log(e)}
                                            col={"col-md-12"} />
                                    </div>
                                </fieldset>
                            ) :
                                field.type === "textarea" ? (
                                    <fieldset className="form-filed text-area-filed col-md-12">
                                        <div className="material">
                                            <FormsyTextAreaAutosize
                                                name={field.name}
                                                value={vehicleAndSoftCreditData && vehicleAndSoftCreditData[field.name]}
                                                placeholder=" "
                                                label={field.label}
                                                onChange={e => handleInputChange(field.name, field.type, e)}
                                                format={field.ApplyNumberformat ? field.format : ""}
                                                required={field.required}
                                                readOnly={(["credit_advice_received"].includes(current_page) && isNeedsToDisable(field?.name, CREDIT_ADVICE_RECEIVED, vehicleAndSoftCreditDataExisted?.[field?.name])) || field.readOnly || form_read_only} />
                                            <label data-label={field.label} className="form-label"></label>
                                        </div>
                                    </fieldset>
                                ) : null

                    ))}
                </div>

                <div className="lead-form-heading">
                    {vehicleAndSoftCreditDocuments?.length ? (<h3><b>Documents Upload</b></h3> ) :  null}
                </div>
                {DocumentUploadHandler(vehicleAndSoftCreditDocuments, form_read_only, markAsFreezed, handleFileChange)}
                <br></br>

                <div className="btn-save-remarks">
                    {isSaveNextDisabled ? <span className="span-disabled">Save & Next</span> : <button type="submit" className="btn-primary" disabled={isSaveNextDisabled}>Save & Next</button>}
                    <button type="button" className="btn-line" onClick={showModalViewTimeLine}>
                        Remarks <span className="m-xs-l">({remarksHistory?.length || 0})</span>
                    </button>
                </div>

            </Formsy>
        </div>
    </div>;
};

export default VehicleTransferCreditInvestigation;

function DocumentUploadHandler(vehicleAndSoftCreditDocuments, form_read_only, markAsFreezed, handleFileChange) {
    return <div className="acco-doc-list">
        <ul>
            {vehicleAndSoftCreditDocuments.map((fields) => (
                <li>
                    <div className='doc-count-txt'>
                        {fields.lead_doc_count === fields.max_upload ? <span className="stepprogress"><i className="sprite ic-check"></i></span> : ""}
                        {fields.doclang && fields.doclang.name}{fields.is_required === "1" ? '*' : ''}
                        <span className="lead-doc-count">{fields.lead_doc_count || 0} / {fields.max_upload}</span>
                    </div>

                    <div className="more-file-upload doc-upload-btn">
                        {fields.lead_doc_count === fields.max_upload || form_read_only || markAsFreezed ?
                            <button aria-label="disabled btn" type="button" className="btn-line" disabled={true}>
                                <i className='ic-upload'></i> Upload
                            </button> :
                            <>
                                <input aria-label="image upload" type="file" name="" accept=".pdf,image/*" disabled={fields.lead_doc_count === fields.max_upload} onChange={e => handleFileChange(e, fields.id, fields.parent_id, fields.max_upload, fields.lead_doc_count)} required={fields.is_required === "1" && !(fields.lead_doc_count >= fields.min_upload)} />
                                <button aria-label="btn image upload" type="button" className="btn-line">
                                    <i className='ic-upload'></i> Upload
                                </button>
                            </>}
                    </div>

                </li>
            ))}
        </ul>
    </div>;
};
